module.exports = __webpack_public_path__ + "static/media/Pharos Logo Final_Horizontal Black.7a8ec82e.svg";